// Validación de rangos de fechas para reportes y exportaciones.
// Es la misma regla que aplica el backend (app/Support/RangoFechas.php): aquí solo se
// adelanta el aviso para no hacer esperar al usuario por una descarga que será rechazada.

const MENSAJE_FALTAN_FECHAS = 'Selecciona la fecha de inicio y la fecha de fin.'
const MENSAJE_FIN_ANTERIOR = 'La fecha de fin no puede ser anterior a la fecha de inicio.'

export const LIMITE_REPORTE_RUTA = {
  maxDias: 3,
  mensaje: 'El reporte muestra la programación de la ruta: selecciona un rango de máximo 3 días.',
}

export const LIMITE_EXPORTACION = {
  maxMeses: 2,
  mensaje: 'La exportación es para la facturación mensual: selecciona un rango de máximo 2 meses.',
}

// "AAAA-MM-DD" → Date local a medianoche (sin desfases de zona horaria), o null si no es válida
function aFecha(valor) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(valor || '')) return null
  const [a, m, d] = valor.split('-').map(Number)
  const fecha = new Date(a, m - 1, d)
  return fecha.getFullYear() === a && fecha.getMonth() === m - 1 && fecha.getDate() === d ? fecha : null
}

// Devuelve el mensaje de error, o null si el rango es válido
export function validarRangoFechas(fechaInicio, fechaFin, { maxDias, maxMeses, mensaje }) {
  const inicio = aFecha(fechaInicio)
  const fin = aFecha(fechaFin)
  if (!inicio || !fin) return MENSAJE_FALTAN_FECHAS
  if (fin < inicio) return MENSAJE_FIN_ANTERIOR

  const maximo = new Date(inicio)
  if (maxDias) {
    maximo.setDate(maximo.getDate() + maxDias - 1)
  } else {
    // Igual que addMonthsNoOverflow(n)->subDay() en el backend: 1/9 + 2 meses → 31/10
    const dia = maximo.getDate()
    maximo.setDate(1)
    maximo.setMonth(maximo.getMonth() + maxMeses)
    const ultimoDia = new Date(maximo.getFullYear(), maximo.getMonth() + 1, 0).getDate()
    maximo.setDate(Math.min(dia, ultimoDia) - 1)
  }
  return fin > maximo ? mensaje : null
}

// Mensaje del backend en una descarga fallida (responseType: 'blob' entrega el JSON como Blob)
export async function mensajeErrorDescarga(error, porDefecto) {
  const datos = error && error.response && error.response.data
  try {
    const texto = datos instanceof Blob ? await datos.text() : JSON.stringify(datos)
    const json = JSON.parse(texto)
    if (json && json.message) return json.message
  } catch (e) {
    // sin mensaje legible: se usa el genérico
  }
  return porDefecto
}
